import day from './day';
import night from './night';

const mapStyles = { day, night };

export function getCurrentTimeStyle() {
  const date = new Date();
  return date.getHours() < 20 ? mapStyles.day : mapStyles.night;
}

export default mapStyles;
